
<form
  :class="classes(n())"
  @submit.prevent="handleSubmit"
>
  <slot />
</form>
